export default __webpack_public_path__ + "static/media/shekhar.e6ab1b9e.png";